import type React from 'react';
import { AuthProvider } from '../contexts/AuthContext';
import { SpecProvider } from '../contexts/SpecContext';
import { ThemeProvider } from '../contexts/ThemeContext';
import { AppContent } from './AppContent';

export const App: React.FC = () => (
  <ThemeProvider>
    <AuthProvider>
      <SpecProvider>
        <AppContent />
      </SpecProvider>
    </AuthProvider>
  </ThemeProvider>
);
